function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.52032 0.358917C2.58291 0.146125 2.7782 0 3 0H7C7.16073 0 7.31165 0.0772606 7.40563 0.207645C7.4996 0.338029 7.52517 0.50564 7.47435 0.658114L5.69372 6H9.5C9.69097 6 9.86526 6.10878 9.94916 6.28032C10.0331 6.45187 10.0119 6.65623 9.89468 6.80697L2.89468 15.807C2.74649 15.9975 2.48334 16.055 2.26922 15.9436C2.05509 15.8321 1.95113 15.5837 2.02211 15.353L3.82302 9.5H0.500004C0.342427 9.5 0.19407 9.42572 0.0996659 9.29955C0.00526185 9.17338 -0.0241415 9.01009 0.0203215 8.85892L2.52032 0.358917ZM3.37412 1L1.16824 8.5H4.5C4.65868 8.5 4.80793 8.57531 4.9022 8.70295C4.99647 8.83058 5.02456 8.99539 4.97789 9.14704L3.78016 13.0397L8.47768 7H5C4.83928 7 4.68836 6.92274 4.59438 6.79236C4.50041 6.66197 4.47484 6.49436 4.52566 6.34189L6.30629 1H3.37412Z",
  fill: "#969BFF"
});

var SvgSpark = function SvgSpark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spark.22ae1757.svg";
export { ForwardRef as ReactComponent };